import React from 'react';

import { lang } from 'src/helpers';

export const TabMenu = React.memo(
  ({
    tabs,
    tab,
    setTab,
    className = '',
    liClassName = '',
    type = 'tab',
    isMulti = false,
    ...props
  }) => {
    const selectedTabs = isMulti ? tab : [tab];
    return (
      <ul className={`mc-${type}-menu ` + className} {...props}>
        {tabs.map((item) => {
          return (
            <li
              data-testid='tab-menu-item'
              data-tab-id={item.id}
              className={
                `mc-${type}-menu-li ${
                  selectedTabs.findIndex((v) => v.id === item.id) > -1 ? 'mc-active ' : ' '
                }` + liClassName
              }
              key={'mc-tab-menu-' + item.id}
              onClick={() => setTab(item)}
            >
              {['string', 'number'].includes(typeof item.name) ? lang.t(item.name) : item.name}
            </li>
          );
        })}
      </ul>
    );
  }
);
TabMenu.displayName = 'TabMenu';

export const TabBox = React.memo(() => {});
TabBox.displayName = 'TabBox';
